import { BulbOutlined } from '@ant-design/icons'

import Box from '~/core/Box'
import Text from '~/core/Text'
import getColor from '~/lib/getColor'

const ProTip = () => (
    <Box
        alignItems="center"
        backgroundColor="grey2"
        borderRadius="4px"
        padding="16px"
    >
        <BulbOutlined
            style={{
                color: getColor('blackAlpha65'),
                fontSize: '24px',
                marginRight: '12px',
            }}
        />
        <div style={{ fontSize: '11px' }}>
            <Text fontWeight={500}>Pro tip!</Text> Use your arrow keys to
            navigate to previous and next slides.
        </div>
    </Box>
)

export default ProTip
